import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { VerticalDescriptor } from '@/core/vertical-engine/types';
import BuildProComponent from '../../../_module/buildpro/BuildPro';
import type { DBAdapter } from '../../../_module/buildpro/types';
import ObrasPage from './pages/ObrasPage';
import EquipoPage from './pages/EquipoPage';
import ControlHorarioPage from './pages/ControlHorarioPage';
import CostesPage from './pages/CostesPage';
import SeguimientoPage from './pages/SeguimientoPage';

const MEM_QUOTES: Array<{ id: string; items: unknown[] }> = [];

const bridgeAdapter: DBAdapter = {
  saveQuote: async (q) => {
    const id = `bp-${Date.now()}`;
    MEM_QUOTES.push({ id, items: q.items ?? [] });
    return id;
  },
  upsertItems: async () => {},
  getQuotes: async () => [],
};

function BuildProWithNav() {
  const navigate = useNavigate();
  return React.createElement(BuildProComponent, {
    dbAdapter: bridgeAdapter,
    onQuoteSaved: (quoteId: string) => {
      const saved = MEM_QUOTES.find(q => q.id === quoteId);
      const items = saved?.items ?? [];
      navigate('/quotes', {
        state: {
          createWithItems: items.map((it: any) => ({
            description: it.description ?? it.name ?? '',
            quantity: it.quantity ?? it.qty ?? 1,
            unitPrice: it.unitPrice ?? it.price ?? 0,
            total: it.total ?? (it.quantity ?? 1) * (it.unitPrice ?? it.price ?? 0),
          })),
        },
      });
    },
  });
}

export const buildproVertical: VerticalDescriptor = {
  id: 'buildpro',
  name: 'BuildPro',
  version: '1.0.0',
  menu: [
    { key: 'buildpro:obras',     label: 'Obras',            path: '/obras',          to: '/obras',          icon: 'HardHat',     order: 9 },
    { key: 'buildpro:seguim',    label: 'Seguimiento',      path: '/seguimiento',    to: '/seguimiento',    icon: 'TrendingUp',  order: 10 },
    { key: 'buildpro:equipo',    label: 'Equipo',           path: '/equipo',         to: '/equipo',         icon: 'Users',       order: 11 },
    { key: 'buildpro:horario',   label: 'Control Horario',  path: '/horario',        to: '/horario',        icon: 'Clock',       order: 12 },
    { key: 'buildpro:costes',    label: 'Costes Reales',    path: '/costes',         to: '/costes',         icon: 'TrendingDown', order: 13 },
    { key: 'buildpro:planos',    label: 'Presupuestos IA',  path: '/presupuestos',   to: '/presupuestos',   icon: 'Calculator',  order: 14 },
  ],
  routes: [
    { path: '/obras',         element: React.createElement(ObrasPage),          wrapInLayout: true },
    { path: '/seguimiento',   element: React.createElement(SeguimientoPage),    wrapInLayout: true },
    { path: '/equipo',        element: React.createElement(EquipoPage),         wrapInLayout: true },
    { path: '/horario',       element: React.createElement(ControlHorarioPage), wrapInLayout: true },
    { path: '/costes',        element: React.createElement(CostesPage),         wrapInLayout: true },
    { path: '/presupuestos',  element: React.createElement(BuildProWithNav),    wrapInLayout: true },
  ],
};
